import React, { useEffect, useState } from 'react';
import ajax from '@/scripts/ajax';
import { getListPayload } from '@/scripts/utils';
// import { TABLE_DATA_DEFAULT } from '@/scripts/config';
import { Button, Form, Table } from 'antd';
import useFormSyncToUrl from '@/hooks/useFormSyncToUrl';
import { getPageTableInfo } from '@/scripts/pageApi';

/**
 * 搜索列表钩子函数

 * @param form 表单对象
 * @param beforeFetch 提交之前调用，如果存在返回值，则会使用该值进行搜索
 * @param fetchUrl 数据源地址
 * @param fetchDataFormat // 服务器数据格式化
 * @param tableConfig 表格配置项
 * @param pageSize // 单页展示数据量
 * @returns {{renderTable: (function(): *), renderSearchButton: (function(): *), research: research}}
 */

const defaultPageSize = 10;
// const defaultFetchManner = 'post';

export default function useSearchList({ pageKey, tableConfig = {}, form, beforeFetch, fetchDataFormat }) {
    const { fetchUrl, fetchManner, getFetchFormat, TABLE_DATA_DEFAULT } = getPageTableInfo(pageKey);
    const { setMemory, loadMemory } = useFormSyncToUrl(form);
    const [tableData, setTableData] = useState(TABLE_DATA_DEFAULT);
    const [isSearching, setIsSearching] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(tableConfig.pageSize || defaultPageSize);
    // const [modulefetchManner, setModuleFetchManner] = useState(fetchManner || defaultFetchManner);
    useEffect(() => {
        research();
    }, []);

    // 使用现有数据重新搜索
    const research = () => {
        const { pageNum = 1, pageSize } = loadMemory();
        setCurrentPage(+pageNum);
        handleSearchSubmit({ pageNum: +pageNum, pageSize: pageSize || currentPageSize });
    };

    // 处理搜索提交
    const handleSearchSubmit = async ({ pageNum, pageSize }) => {
        setCurrentPage(pageNum);
        setIsSearching(true);
        const formValue = beforeFetch ? beforeFetch(form) : null;
        let queryData =
            fetchManner === 'get'
                ? { params: getListPayload({ form, formValue, pageNum, pageSize }) }
                : getListPayload({ form, formValue, pageNum, pageSize });

        let ajaxData = await ajax[fetchManner](fetchUrl, queryData).catch((err) => {
            console.log(err);
        });
        setIsSearching(false);
        if (fetchDataFormat) ajaxData = fetchDataFormat(ajaxData);
        // if (fetchManner === 'get') ajaxData = getFetchFormat(ajaxData);
        if (ajaxData) {
            // setMemory({ pageNum });
            setTableData(ajaxData || TABLE_DATA_DEFAULT);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // 渲染搜索按钮
    const renderSearchButton = (options = {}) => {
        const { itemStyle = {} } = options;
        return (
            <Form.Item style={itemStyle}>
                <div className="ax-search-buttons">
                    <Button
                        type="primary"
                        onClick={() => handleSearchSubmit({ pageNum: 1, pageSize: currentPageSize })}
                        loading={isSearching}
                    >
                        搜索
                    </Button>
                </div>
            </Form.Item>
        );
    };

    // 处理表格变动
    const handleTableChange = (pagination) => {
        const { current: pageNum, pageSize } = pagination;
        setCurrentPageSize(pageSize);
        handleSearchSubmit({ pageNum, pageSize });
    };

    // 渲染表格
    const renderTable = () => {
        const generateTable = (key) => {
            if (key === 'get') {
                // if (tableData.length === 0) return '';
                return (
                    <Table
                        dataSource={tableData}
                        pagination={{
                            total: tableData[tableConfig.totalKey],
                            hideOnSinglePage: true,
                            current: currentPage,
                            size: 'default',
                            pageSize: currentPageSize,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            pageSizeOptions: [10, 20, 50, 100, 500, 1000, 2000],
                        }}
                        onChange={handleTableChange}
                        size="middle"
                        scroll={{ x: 'max-content' }}
                        {...tableConfig}
                    ></Table>
                );
            } else {
                return (
                    <Table
                        dataSource={tableData[tableConfig.dataKey]}
                        pagination={{
                            total: tableData[tableConfig.totalKey],
                            hideOnSinglePage: true,
                            current: currentPage,
                            size: 'default',
                            pageSize: currentPageSize,
                            showQuickJumper: true,
                            showSizeChanger: true,
                        }}
                        onChange={handleTableChange}
                        size="middle"
                        scroll={{ x: 'max-content' }}
                        {...tableConfig}
                    ></Table>
                );
            }
        };
        return generateTable(fetchManner);
    };

    return { research, renderSearchButton, renderTable };
}
